import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

import { useCosaFareOggi } from "@/hooks/useDashboard";
import { cn } from "@/lib/utils";

type Tono = "amber" | "brand" | "slate";

const TONO_STILE: Record<Tono, { box: string; valore: string; label: string }> = {
  amber: {
    box: "border-amber-200 bg-amber-50",
    valore: "text-amber-700",
    label: "text-amber-800",
  },
  brand: {
    box: "border-brand-200 bg-brand-50",
    valore: "text-brand-700",
    label: "text-brand-800",
  },
  slate: {
    box: "border-slate-200 bg-slate-50",
    valore: "text-slate-700",
    label: "text-slate-600",
  },
};

export function WidgetCosaFareOggi() {
  const { data, isLoading } = useCosaFareOggi();

  if (isLoading) {
    return <Loader2 className="size-4 animate-spin text-muted-foreground" />;
  }
  if (!data) return null;

  const box: { count: number; label: string; tono: Tono }[] = [
    {
      count: data.spedizioni_in_pianificazione,
      label: "Carichi da confermare",
      tono: "amber",
    },
    {
      count: data.spedizioni_pianificate,
      label: "Carichi da far partire",
      tono: "brand",
    },
    {
      count: data.documenti_firme_attese,
      label: "Firme fisiche attese",
      tono: "slate",
    },
    {
      count: data.spedizioni_oversize,
      label: "Carichi oversize",
      tono: "slate",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {box.map((b) => {
        const stile = TONO_STILE[b.tono];
        const spento = b.count === 0;
        return (
          <Link
            key={b.label}
            to="/moduli/spedizioni"
            className={cn(
              "rounded-lg border p-4 transition-colors hover:brightness-[0.98]",
              spento ? "border-slate-200 bg-slate-50" : stile.box
            )}
          >
            <div
              className={cn(
                "text-2xl font-semibold tabular-nums",
                spento ? "text-slate-400" : stile.valore
              )}
            >
              {b.count}
            </div>
            <div
              className={cn(
                "mt-1 text-xs",
                spento ? "text-slate-500" : stile.label
              )}
            >
              {b.label}
            </div>
          </Link>
        );
      })}
    </div>
  );
}
